import {
  ROUTE_COURSE_ADMIN,
  ROUTE_COHORT_ADMIN,
  ROUTE_COURSE_ASSESSMENT,
  ROUTE_COURSE_PROGRESS,
  ROUTE_COURSE_CERTIFICATION,
  RouteAction,
  RouteInCourseWithQuery,
  RouteInCourseWithPaginationQuery,
} from '../../routeActions';

export const routeIsInCourseWithQueryParam = (
  action: RouteAction
): action is RouteInCourseWithQuery => {
  switch (action.type) {
    case ROUTE_COURSE_ADMIN:
    case ROUTE_COHORT_ADMIN:
    case ROUTE_COURSE_ASSESSMENT:
    case ROUTE_COURSE_PROGRESS:
    case ROUTE_COURSE_CERTIFICATION: {
      return true;
    }
    default: {
      return false;
    }
  }
};

export const routeIsInCourseWithPaginationQueryParam = (
  action: RouteAction
): action is RouteInCourseWithPaginationQuery => {
  switch (action.type) {
    case ROUTE_COURSE_ADMIN: {
      return true;
    }
    default: {
      return false;
    }
  }
};
